var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6059_1544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8046 24.2139L11.1451 24.6679C12.6772 26.7107 15.7415 26.7107 17.2736 24.6679L17.6141 24.2139M5.33747 18.0281L5.45477 18.2699C6.20809 19.823 7.78249 20.8091 9.50859 20.8091H18.8386C20.3177 20.8091 21.6943 20.0535 22.4885 18.8056C23.6096 17.0441 23.3127 14.7333 21.7827 13.3124L21.7329 13.2662C20.6941 12.3015 20.1827 10.8961 20.3585 9.48941L20.4319 8.90273C20.8469 5.58279 18.2582 2.65039 14.9124 2.65039H12.9798C9.63806 2.65039 7.05254 5.57921 7.46703 8.89511L7.55709 9.61561C7.72295 10.9425 7.23828 12.2678 6.25556 13.1747C4.91327 14.4133 4.54035 16.3848 5.33747 18.0281Z",
    stroke: "white",
    strokeWidth: 1.85714,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6059_1544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2381,
    height: 27.2381,
    fill: "white",
    transform: "translate(0.382812 0.380859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification1);
export default __webpack_public_path__ + "static/media/Notification 1.696c51b2aea30721c0963d71ba185c74.svg";
export { ForwardRef as ReactComponent };